// @core/stores/project/ProjectTimelineStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { projectApi } from '@core/api';
import type {
  TimelineResponse,
} from '@core/types/project';

class ProjectTimelineStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get timeline view
   */
  async GetTimeline(project_id: string): Promise<TimelineResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await projectApi.GetTimeline(project_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const projectTimelineStore = new ProjectTimelineStore();
